import React from "react";
import ProfileCard from "./ProfileCard";

// categories come from the server already filtered to the user's roles.
export default function NotificationsCard({ categories, prefs, onToggle }) {
  return (
    <ProfileCard id="notifications" title="Notifications" subtitle="Choose which emails you get about activity on your account.">
      {categories.length === 0 ? (
        <div className="pf-empty">No notification settings are available for your account yet.</div>
      ) : (
        <table className="pf-nt">
          <thead>
            <tr><th scope="col">Activity</th><th scope="col">Email</th><th scope="col">Text <small>Coming soon</small></th></tr>
          </thead>
          <tbody>
            {categories.map((c) => (
              <tr key={c.key} data-testid={`notification-row-${c.key}`}>
                <td><b>{c.label}</b><small>{c.description}</small></td>
                <td>
                  <button
                    type="button"
                    className="pf-sw"
                    role="switch"
                    data-testid={`notification-email-${c.key}`}
                    aria-checked={prefs[c.key]?.email !== false}
                    aria-label={`${c.label} by email`}
                    onClick={() => onToggle(c.key, prefs[c.key]?.email === false)}
                  />
                </td>
                <td>
                  <button type="button" className="pf-sw" role="switch" disabled aria-checked={false} aria-label={`${c.label} by text (coming soon)`} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <p className="pf-note">Security emails, like password and sign-in alerts, are always sent.</p>
    </ProfileCard>
  );
}
